export const MEDIA_TABLET = 768;
export const MEDIA_DESKTOP = 1250;
